import { callAll } from "../../../utils/call-all";
import { useScrollBarContext } from "../scroll-bar.context";
import styles from "../scroll-bar.module.scss";
import type { ScrollBarThumbProps } from "../types-scroll-bar";

export function ScrollBarThumb({
  className,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerCancel,
  ...rest
}: ScrollBarThumbProps) {
  const { railRef, thumbRef, dragging, thumbHandlers, partTestId } = useScrollBarContext();

  return (
    <div ref={railRef} className={styles.rail}>
      <div
        ref={thumbRef}
        className={[styles.thumb, className].filter(Boolean).join(" ")}
        data-testid={partTestId("thumb")}
        data-dragging={dragging}
        {...rest}
        onPointerDown={callAll(thumbHandlers.onPointerDown, onPointerDown)}
        onPointerMove={callAll(thumbHandlers.onPointerMove, onPointerMove)}
        onPointerUp={callAll(thumbHandlers.onPointerUp, onPointerUp)}
        onPointerCancel={callAll(thumbHandlers.onPointerCancel, onPointerCancel)}
      />
    </div>
  );
}
ScrollBarThumb.displayName = "ScrollBar.Thumb";
